import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import PriceSection from './PriceSection'

function AdditionalViews({ price = null, count = null }) {
  numeral.localeData().delimiters.thousands = ' '

  return (
    <PriceSection
      value={price}
      units=""
      isSecondary
    >
      {count && (
        <div className="pricing-plan__description text-light-grey">
          for <strong>{numeral(count).format('0,0')}</strong> additional views
        </div>
      )}
    </PriceSection>
  )
}

AdditionalViews.propTypes = {
  price: PropTypes.number,
  count: PropTypes.number,
}

export default AdditionalViews
